import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import {
    cn
} from 'shared/lib/utils';

export interface ProgressProps
  extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
  value?: number
}
const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>, // what the ref points to
  ProgressProps // props type
>(({
    className, value, ...props
}, ref) => (
    <ProgressPrimitive.Root
        ref={ref}
        className={cn(
            'relative h-2 w-full overflow-hidden rounded-full bg-primary/20',
            className
        )}
        {...props}>
        <ProgressPrimitive.Indicator
            className="h-full w-full flex-1 bg-primary transition-all"
            style={{
                transform: `translateX(-${100 - (value || 0)}%)`
            }} />
    </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
